import Vue from 'vue'
import 'core-js/stable'
import 'regenerator-runtime/runtime'
import { initSentry } from '../../sentry/main'
import PlanbkTemplate from './PlanbkTemplate.vue'
// import FastClick from 'fastclick'

// FastClick.attach(document.body)
Vue.config.productionTip = false

initSentry(Vue)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: h => h(PlanbkTemplate)
})
